const ROLES = Object.freeze({
  AML_OFFICER: 'Aml-Officer',
  BOARD_MEMBER: 'Board-Member',
  EMPLOYEE: 'Employee',
  KYC_OPERATOR: 'KYC-Operator',
  RISK_ANALYST: 'Risk-Analyst',
  SAR_INVESTIGATOR: 'SAR-Investigator',
  USER: 'User',
  WHISTLEBLOWING_OFFICER: 'Whistleblowing-Officer',
});

export default Object.freeze({
  ROLES,
});
